import React from 'react';
import styled from 'styled-components';
import { useQuery } from '@tanstack/react-query';
import { TExamsInfo } from 'app.type/examsInfo';
import ExamApi from 'lib/api/exam';
import { useRouter } from 'next/router';
import CbtRoundTableFooter from 'app.feature/academy/cbt.detail/component/CbtDetailMoreButton';
import CommunityWriteButton from 'app.component/communityBoard/button/CommunityWriteButton';
import CommunityPostList from 'app.component/communityBoard/CommunityPostList';
import { useRecoilValue } from 'recoil';
import { projectConfigState } from 'recoil/Academy/projectConfigState';

const CommunityBoard = () => {
  const router = useRouter();
  const examIdx = Number(router.query.examIdx);
  const { communityUrl = '' } = useRecoilValue(projectConfigState);

  const { data: examInfo, isLoading } = useQuery<TExamsInfo>({
    queryKey: [`/apiV2/exams/${examIdx}`],
    queryFn: () => ExamApi.getExamInfo(examIdx),
  });

  if (isLoading) return null;

  const { title: boardTitle, id: boardId } = examInfo?.board || {};
  const postsData = examInfo?.board?.posts.nodes || [];
  const postsTotalCount = examInfo?.board?.posts.totalCount || 0;
  const maxVisiblePosts = 15;
  const communityBoardSlug = examInfo?.communityBoardId || '';

  const handleShowMore = () => {
    router.push(`${communityUrl}/${communityBoardSlug}`);
  };

  return (
    <StyledWrapper>
      <Header>
        <p>위 시험과 관련된 게시글이에요.</p>
        {postsData?.length > 0 && boardId && (
          <CommunityWriteButton communityUrl={communityUrl} boardId={boardId} width={183} />
        )}
      </Header>
      <CommunityPostList
        postsData={postsData}
        communityUrl={communityUrl || ''}
        boardTitle={boardTitle}
        boardId={boardId}
        maxVisiblePosts={maxVisiblePosts}
        communityBoardSlug={communityBoardSlug}
      />
      {postsData && postsTotalCount > maxVisiblePosts && (
        <CbtRoundTableFooter handleShowMore={handleShowMore} arrow={'right'} />
      )}
      {postsData?.length == 0 && (
        <article className="empty">
          <p>
            이해가 안되거나 궁금한 점이 있다면
            <br /> 시험 정보방에 질문을 남겨보세요!
          </p>
          <CommunityWriteButton communityUrl={communityUrl} boardId={boardId} width={271} />
        </article>
      )}
    </StyledWrapper>
  );
};

export default CommunityBoard;

const StyledWrapper = styled.div`
  margin: 40px auto;

  .empty {
    width: 100%;
    border: 1px solid #e0e0e0;
    border-radius: 15px;
    margin: 40px auto;
    padding: 50px 10px;
    text-align: center;

    p {
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 20px;
    }
  }

  @media ${({ theme }) => theme.device.mobile} {
    margin: 20px auto;

    .empty {
      margin: 16px auto 40px;
      padding: 32px 10px;

      p {
        font-size: 13px;
      }
    }
  }
`;

const Header = styled.div`
  padding: 0 0 20px 0;
  display: flex;
  align-items: end;
  justify-content: space-between;
  border-bottom: 1px solid #666;

  p {
    margin: 0;
    font-size: 15px;
    color: #666;
    font-weight: 500;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 0 0 16px 0;
    p {
      font-size: 14px;
    }
  }
`;
